export function isShowMore(responseDataLength: number, limit: number) {
    if (!(limit > 0)) {
        return false;
    }

    if (responseDataLength === limit) {
        return true;
    }

    return false;
}

export function getDynamicLimit(limit: number, offset: number) {
    const offsetDelta = limit - (offset % limit);
    if (offsetDelta === 0 || offsetDelta === limit) {
        return limit;
    }

    return limit + offsetDelta;
}